// @flow

import React from 'react'
import { tracking } from 'lib/analytics'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import { v2black, v2neutral200, v2grey600, Link } from '@paypalcorp/pp-react'
import { V2ImageIcon } from '@paypalcorp/pp-react'
import { getFormattedAmount } from '../amount-utils'
import Events from 'lib/analytics/event-tags'
import {
  smallAndSmaller,
  phoneLandscapeMinAndSmaller,
  phoneLandscapeMaxAndSmaller,
} from 'lib/styles/media-queries'

const FadeIn = css.keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  color: v2black,
  marginBottom: '20px',
  '& .productText': {
    color: 'inherit',
    fontWeight: 'normal',
    fontSize: '0.857rem',
    fontFamily: 'inherit',
    textAlign: 'left',
    lineHeight: '1.25',
    marginBottom: '10px',
  },
  '& .productName': {
    display: '-webkit-box',
    verticalAlign: 'middle',
    textOverflow: 'ellipsis',
    width: '100%',
    overflow: 'hidden',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
  },
  '& .productPrice': {
    marginBottom: '10px',
    lineHeight: '1',
  },
})

const ProductImage = glamorous.img(({ photoHeightLg, photoHeightSm }) => ({
  width: '100%',
  height: photoHeightLg,
  borderRadius: '15px',
  marginBottom: '5px',
  animation: `${FadeIn} 0.5s`,
  [smallAndSmaller]: {
    height: photoHeightSm,
  },
  [phoneLandscapeMaxAndSmaller]: {
    height: '175px',
  },
  [phoneLandscapeMinAndSmaller]: {
    height: '150px',
  },
}))

const NullImage = glamorous.div({
  width: '128px',
  height: '128px',
  background: v2neutral200,
  color: v2grey600,
  borderRadius: '12px',
  marginBottom: '5px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

ProductMiniView.defaultProps = {
  photoUrl: 'https://www.paypalobjects.com/profiles/cover/green.jpg',
  price: {},
  photoHeightLg: '105px',
  photoHeightSm: '185px',
}

ProductMiniView.propTypes = {
  photoUrls: PropTypes.exact({
    imageDetails: PropTypes.exact({
      referenceUrl: PropTypes.string,
    }),
  }),
  name: PropTypes.string,
  id: PropTypes.string,
  price: PropTypes.exact({
    currencyCode: PropTypes.string,
    value: PropTypes.string,
  }),
}

function ProductMiniView(props) {
  const {
    photoUrl,
    name,
    price,
    photoHeightLg,
    photoHeightSm,
    id,
    slug,
    shopsBuyerState = {},
  } = props

  const handleProductClick = () => {
    tracking(Events.public_identity_shop_product_list_item_pressed())
    shopsBuyerState.setCurrentProductId(id)
    props.history.push(`/${slug}/products/${id}`)
  }

  return (
    <Container>
      <Link
        onClick={() => {
          handleProductClick()
        }}
      >
        {photoUrl === null ? (
          <NullImage>
            <V2ImageIcon />
          </NullImage>
        ) : (
          <ProductImage
            photoHeightLg={photoHeightLg}
            photoHeightSm={photoHeightSm}
            alt={name}
            src={photoUrl}
          />
        )}
      </Link>

      <Link
        onClick={() => {
          handleProductClick()
        }}
        className="productName productText"
      >
        {name}
      </Link>

      <Link
        className="productText"
        onClick={() => {
          handleProductClick()
        }}
      >
        <strong className="productPrice">
          {getFormattedAmount({
            amount: price.value,
            currencyCode: price.currencyCode,
          })}
        </strong>
      </Link>
    </Container>
  )
}

export default ProductMiniView
